var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home__page"},[_c('navbar'),_c('main-homepage'),_c('cadastre-empresa'),_c('download'),_c('dicas'),_c('vantagens'),_c('realizacao'),_c('parceria'),_c('apoio'),_c('estatisticas'),_c('faq'),_c('contato'),_c('footer-homepage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }